import { render, staticRenderFns } from "./VaimoNewsletterSubscription.vue?vue&type=template&id=f4f833f0&"
import script from "./VaimoNewsletterSubscription.vue?vue&type=script&lang=ts&"
export * from "./VaimoNewsletterSubscription.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoNewsletterSubscription.vue?vue&type=style&index=0&id=f4f833f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports